/* Science of Scent — carousel. Page-scoped, no dependencies. */
(function () {
  function init(root) {
    if (root.dataset.sosReady === 'true') return;
    root.dataset.sosReady = 'true';

    var track  = root.querySelector('[data-sos-track]');
    var slides = root.querySelectorAll('[data-sos-slide]');
    var dots   = root.querySelectorAll('[data-sos-dot]');
    var prev   = root.querySelector('[data-sos-prev]');
    var next   = root.querySelector('[data-sos-next]');
    var count  = slides.length;
    var i = 0;

    if (!track || count < 2) {
      if (prev) prev.style.display = 'none';
      if (next) next.style.display = 'none';
      root.querySelectorAll('[data-sos-dots]').forEach(function (d) { d.style.display = 'none'; });
      return;
    }

    function paint() {
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      slides.forEach(function (s, n) {
        s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
      });
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    function go(n) { i = (n + count) % count; paint(); }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { go(i - 1); }
      if (e.key === 'ArrowRight') { go(i + 1); }
    });

    // Touch swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 44) { go(dx < 0 ? i + 1 : i - 1); }
      x0 = null;
    }, { passive: true });

    paint();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-sos-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme editor re-renders sections without a page reload.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
